import { NAME } from './constants'

export const getFolderS3List = (state) => state[NAME].folderS3List
